import { useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const QRRedirectPage = () => {
  const { userId, codeId } = useParams();
  const [searchParams] = useSearchParams();
  const locationCode = searchParams.get('location');
  const gruppe = searchParams.get('gruppe');
  const code = searchParams.get('code');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const performRedirect = async () => {
      try {
        // New format: query parameters (location or legacy gruppe), legacy: path parameters
        const endpoint = (locationCode || gruppe) && code
          ? `${BACKEND_URL}/api/qr/resolve?${locationCode ? `location=${encodeURIComponent(locationCode)}` : `gruppe=${encodeURIComponent(gruppe)}`}&code=${encodeURIComponent(code)}`
          : `${BACKEND_URL}/api/qr/redirect/${userId}/${codeId}`;
        const response = await axios.get(endpoint, {
          maxRedirects: 0,
          validateStatus: (status) => status >= 200 && status < 400
        });
        
        // If we get a redirect URL in the response
        if (response.data?.redirect_url) {
          window.location.href = response.data.redirect_url;
        } else if (response.headers?.location) {
          window.location.href = response.headers.location;
        } else {
          setError('Kein Weiterleitungsziel gefunden');
          setLoading(false);
        }
      } catch (err) {
        // Check if it's a redirect response (302/307)
        if (err.response?.status === 302 || err.response?.status === 307) {
          const redirectUrl = err.response.headers?.location;
          if (redirectUrl) {
            window.location.href = redirectUrl;
            return;
          }
        }
        
        console.error('Redirect error:', err);
        setError(err.response?.data?.detail || 'QR-Code nicht gefunden');
        setLoading(false);
      }
    };

    if (((locationCode || gruppe) && code) || (userId && codeId)) {
      performRedirect();
    } else {
      setError('QR-Code nicht gefunden');
      setLoading(false);
    }
  }, [userId, codeId, locationCode, gruppe, code]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-purple">
        <div className="text-center text-off">
          <div className="animate-spin rounded-full h-12 w-12 border-4 border-off border-t-transparent mx-auto mb-4"></div>
          <p className="font-display font-bold text-lg">Weiterleitung...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-purple">
        <div className="card-ink card-ink--shadow p-8 max-w-md mx-4 text-center">
          <div className="w-16 h-16 border-2 border-ink bg-lilac flex items-center justify-center mx-auto mb-4">
            <svg className="w-8 h-8 text-ink" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </div>
          <h1 className="font-display font-bold text-2xl mb-2">Fehler</h1>
          <p className="text-ink/80 mb-6">{error}</p>
          <a 
            href="https://gastro-beratung.de" 
            className="btn btn--purple"
          >
            Zur Startseite
          </a>
        </div>
      </div>
    );
  }

  return null;
};

export default QRRedirectPage;
